<template>
    <v-card flat tile class="my-3">
        <v-toolbar dense flat dark color="primary" class="clickable" @click="goto" v-track="{ category: 'Sector Snapshot', action: 'click', label: this.sector }">
            <v-row no-gutters align="center">
                <v-col>
                    <v-toolbar-title class="title text-uppercase font-weight-bold">
                        <v-icon left>{{ icon(sector) }}</v-icon>
                        <span>{{ sector }}</span>
                    </v-toolbar-title>
                </v-col>
                <v-col cols="auto" class="text-right">
                    <span class="title ml-3">
                        <a class="white--text">
                            <span>See All</span>
                            <v-icon right>mdi-arrow-right</v-icon>
                        </a>
                    </span>
                </v-col>
            </v-row>
        </v-toolbar>
        <v-row no-gutters>
            <v-col>
                <SnapshotCount :icon="icon('Standards')" :value="summary[sector].total" label="Total Number of Standards"></SnapshotCount>
            </v-col>
            <v-col>
                <SnapshotCount :icon="icon('Available')" :value="summary[sector]['Available']" label="Number Published / Released"></SnapshotCount>
            </v-col>
            <v-col>
                <SnapshotCount :icon="icon('In Development')" :value="summary[sector]['In Development']" label="Number In Development"></SnapshotCount>
            </v-col>
            <v-col>
                <SnapshotCount :icon="icon('Area of Need')" :value="summary[sector]['Area of Need']" label="Areas of Need"></SnapshotCount>
            </v-col>
        </v-row>
        <v-card flat tile outlined color="primary">
            <v-card flat tile outlined color="white" class="px-5">
                <Chart :options="chartOptions" class="mt-6"></Chart>
                <v-row justify="center" align="center">
                    <v-col cols="6">
                        <v-row justify="center" align="center" class="px-12" v-for="(functionalArea, index) in functionalAreas.slice(0, 3)" :key="index">
                            <v-col cols="auto">
                                <v-icon size="36" color="orange">{{ icon(functionalArea) }}</v-icon>
                            </v-col>
                            <v-col>
                                <div class="subtitle-1">{{ functionalArea }}</div>
                            </v-col>
                            <v-col cols="auto">
                                <div class="display-1 text-right">{{ summary[sector][functionalArea] }}</div>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-row justify="center" align="center" class="px-12" v-for="(functionalArea, index) in functionalAreas.slice(3)" :key="index">
                            <v-col cols="auto">
                                <v-icon size="36" color="orange">{{ icon(functionalArea) }}</v-icon>
                            </v-col>
                            <v-col>
                                <div class="subtitle-1">{{ functionalArea }}</div>
                            </v-col>
                            <v-col cols="auto">
                                <div class="display-1 text-right">{{ summary[sector][functionalArea] }}</div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card>
        </v-card>
    </v-card>
</template>

<script>
    import { get } from 'vuex-pathify';
    import { colors, icon } from '@/common';
    import Chart from '@/components/Chart';
    import SnapshotCount from '@/components/SnapshotCount';
    import router from '@/router';

    export default {
        components: { Chart, SnapshotCount },
        props: {
            sectorIndex: {
                type: Number,
                required: true
            }
        },
        computed: {
            summary: get('summary'),
            functionalAreas: get('common@functionalAreas'),
            sectors: get('common@sectors'),
            sector() {
                return this.sectors[this.sectorIndex];
            },
            availableByYear() {
                return this.$store.get('availableByYear', this.sector);
            },
            chartOptions() {
                return {
                    title: {
                        text: 'Number of Standards Published/Released by Year',
                        left: 'center',
                        textStyle: {
                            color: colors.primary,
                            fontFamily: 'Montserrat, sans-serif'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: this.availableByYear.years,
                        axisLabel: {
                            interval: 0,
                            rotate: 45
                        }
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: this.availableByYear.counts,
                            type: 'bar',
                            cursor: 'default',
                            itemStyle: {
                                color: colors.primary
                            },
                            label: {
                                show: true,
                                position: 'top'
                            }
                        },
                    ],
                };
            }
        },
        methods: {
            icon: icon,
            goto() {
                this.$store.commit('resetFilters', true);
                this.$store.set('filters@selectedSectors', [this.sectors[this.sectorIndex]]);
                this.$store.dispatch('search').then(() => {
                    router.push({ path: this.$store.get('searchPath') });
                });
            }
        }
    };
</script>

<style scoped>
    .clickable {
        cursor: pointer;
    }
</style>
